<template>
  <div class="page">
    <div class="m-bg-cover"></div>
    <div class="page2">
      <div class="room-details">
        <div class="room-title">
          <img class="book" src="../../assets/img/home/book.png" alt="">
          考场信息
        </div>
        <div class="info-list" v-for="(item, index) in roomDetails" :key="index">
          <div class="label">{{ item.label }}</div>
          <div class="value">{{ item.value }}</div>
        </div>
      </div>
      <div class="download-btn">
        <div class="btn" @click="download">下载准考证</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showPage: 1,
      loading: false,
      finished: false,
      isLoading: false,
      setId: '',
      token: window.localStorage.getItem('token'),
      selectData: {},
      dataList: [],
      pageNum: 0,
      pageSize: 10,
      total: 0,
      roomDetails: [
        {
          label: '考试',
          value: ''
        },
        {
          label: '准考证号',
          value: ''
        },
        {
          label: '姓名',
          value: ''
        },
        {
          label: '证件号码',
          value: ''
        },
        {
          label: '科目',
          value: ''
        },
        {
          label: '考点',
          value: ''
        },
        {
          label: '考场',
          value: ''
        },
        {
          label: '座位号',
          value: ''
        },
        {
          label: '考试时间',
          value: ''
        },
        {
          label: '考点信息',
          value: ''
        },
      ],
      people:{}
    }
  },
  created() {
    this.getInfo()
    this.selectData = sessionStorage.getItem('selectData') ? JSON.parse(sessionStorage.getItem('selectData')) : {}
  },
  mounted() {
    this.SetData()
  },
  methods: {
    SetData() {
      this.setId = this.selectData.registerId
      this.roomDetails[0].value = this.selectData.examName
      this.roomDetails[1].value = this.selectData.admissionNumb
      this.roomDetails[2].value = this.selectData.userName
      this.roomDetails[3].value = this.selectData.idCardNum
      this.roomDetails[4].value = this.selectData.examSubject
      this.roomDetails[5].value = this.selectData.siteName
      this.roomDetails[6].value = this.selectData.roomName
      this.roomDetails[7].value = this.selectData.seatNum
      this.roomDetails[8].value = `${this.selectData.startTime.substring(0, this.selectData.startTime.length - 3)} - ${this.selectData.endTime ? (this.selectData.endTime.substring(0, this.selectData.startTime.length - 3)).split(' ')[1] : ''}`
      this.roomDetails[9].value = this.selectData.address
      this.showPage = 2
    },
    download() {
      if(this.selectData.realAuthentication==1){
        if(this.people.hasNameAccess!=1){
          this.utils.toastNone('此账号为未实名或已过期的状态，请去个人中心实名认证！')
          return
        }
      }
      if (this.selectData.hasReadAdmissionNotice == 1) {
        this.$router.push({
          path: '/notes',
          query: {
            examId: this.setId
          }
        })
      } else {
        window.open(`/api/app/exam/downLoadAdmission/${this.setId}?token=${this.token}`)
      }
    },
    //    获取个人信息
    getInfo(){
      this.http.postRequest({
        url: 'app/user/getUserInfo',
        msg: {},
        success: (res) => {
          this.people = res.data
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.page {
  // width: 100%;
  // height: 100%;
  background: #F4F6F9;

  .m-bg-cover {
    position: absolute;
    width: 100%;
    height: 180px;
    background: linear-gradient(360deg, #F4F6F9 0%, #2B6CF9 28%, #2B6CF9 100%);
    z-index: -1;
  }

  .m-content {
    padding: 30px 12px 15px 12px;

    .m-box {
      background: #ffffff;
      border-radius: 4px 4px 4px 4px;
      padding: 12px;
      margin-bottom: 16px;

      .m-title {
        font-size: 15px;
        color: #1D232D;
        font-weight: bold;
        line-height: 18px;

      }

      .m-title-text {
        color: #2B6CF9;
        font-size: 15px;
        margin-top: 12px;
        display: flex;
        justify-content: space-between;

        .m-subject {
          height: 32px;
          font-size: 14px;
          font-weight: 400;
          color: #999999;
          line-height: 32px;
        }

        .m-select {
          width: 100px;
          height: 32px;
          background: #F2F6FF;
          border-radius: 4px;
          font-size: 13px;
          font-weight: 400;
          color: #2B6CF9;
          line-height: 32px;
          text-align: center;
        }
      }
    }
  }

  .page2 {
    width: 100%;
    height: 100%;
    padding: 16px 12px;
    box-sizing: border-box;
  }

  .room-details {
    width: 100%;
    height: auto;
    background-color: #fff;
    border-radius: 4px;
    padding: 16px 12px;
    box-sizing: border-box;
    margin-bottom: 40px;
    // overflow: hidden;

    .room-title {
      width: 100%;
      display: flex;
      align-items: center;
      height: 20px;
      font-size: 14px;
      font-weight: 600;
      color: #2B6CF9;
      line-height: 20px;
      margin-bottom: 10px;

      .book {
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }
    }

    .info-list {
      width: 100%;
      display: flex;
      font-size: 14px;
      line-height: 20px;
      padding: 10px 0;
      box-sizing: border-box;

      .label {
        width: 56px;
        color: #8D8F93;
      }

      .value {
        flex: 1;
        color: #1D232D;
        text-align: right;
      }
    }

  }

  .download-btn {
    width: 100%;
    display: flex;
    justify-content: center;

    .btn {
      width: 144px;
      height: 42px;
      background: linear-gradient(270deg, #3A5AF5 0%, #3E8DF6 100%);
      border-radius: 8px;
      font-weight: bold;
      font-size: 14px;
      text-align: center;
      line-height: 42px;
      color: #fff;
    }
  }
}
</style>